import { matchPathWithoutQuery } from '../../query-params';

export function getParams(path, pattern) {
    const match = matchPathWithoutQuery(path, { path: pattern });
    return match ? match.params : {};
}
